import request from '@/utils/request'

/**
 * 获取组件条件列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listReportCustomComponentCondition(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustomComponentCondition.listReportCustomComponentCondition',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加组件条件
 * @param {Object} data 组件条件数据
 * @returns {Promise} Promise对象
 */
export function saveReportCustomComponentCondition(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustomComponentCondition.saveReportCustomComponentCondition',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改组件条件
 * @param {Object} data 组件条件数据
 * @returns {Promise} Promise对象
 */
export function updateReportCustomComponentCondition(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustomComponentCondition.updateReportCustomComponentCondition',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除组件条件
 * @param {Object} data 组件条件数据
 * @returns {Promise} Promise对象
 */
export function deleteReportCustomComponentCondition(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustomComponentCondition.deleteReportCustomComponentCondition',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}